import { closeNavDrawer } from './nav-drawer.js'
import { getFocusableElements } from '../helpers.js'

const elSearchOverlay = document.querySelector('[data-search-overlay]')
const elSearchToggle = document.querySelector('[data-search-toggle]')
const elMobileSearchToggle = document.querySelector(
    '[data-search-toggle-mobile]'
)
let elSearchField
let elToggleTarget // used to set proper focus and attributes on close
let focusableElements

const openSearch = (elToggle) => {
    if (window.posh != null) {
        window.posh.answers.open()
    }
    else {
        document.body.setAttribute('data-search-open', 'true')
        elToggle.setAttribute('aria-expanded', 'true')
        elSearchOverlay.setAttribute('aria-hidden', 'false')
        elSearchField.focus()
        elToggleTarget = elToggle
        focusableElements = getFocusableElements(elSearchOverlay)
        const [finalFocusableElement] = focusableElements.reverse()
    
        document.addEventListener('click', handleClickaway)
        document.addEventListener('keyup', handleEscape)
    
        // Ensure focus move from mobile searh toggle to search field
        elMobileSearchToggle.addEventListener('keydown', (event) => {
            if (event.keyCode === 9 && !event.shiftKey) {
                // Timeout fixes odd bug where focused element also gets tab input and gets skipped
                setTimeout(() => elSearchField.focus(), 1)
            }
        })
    
        // Set focus back to toggle when user tabs away from final link
        finalFocusableElement.addEventListener('keydown', (event) => {
            if (event.keyCode === 9 && !event.shiftKey) {
                console.log(elToggleTarget)
                // Timeout fixes odd bug where focused element also gets tab input and gets skipped
                setTimeout(() => elToggleTarget.focus(), 1)
            }
        })
    
        // Close nav drawer if it's open
        if (document.body.getAttribute('data-nav-drawer-open')) {
            closeNavDrawer()
        }
    }
}

const closeSearch = () => {
    document.body.removeAttribute('data-search-open')
    elToggleTarget.setAttribute('aria-expanded', 'false')
    elSearchOverlay.setAttribute('aria-hidden', 'true')
    elToggleTarget.focus()

    document.removeEventListener('click', handleClickaway)
    document.removeEventListener('keyup', handleEscape)
}

/**
 * Handle closing overlay when clicked outside
 */
const handleClickaway = () => {
    closeSearch()
}

/**
 * Handle closing overlay when escape is pressed
 * @param event {Event}
 */
const handleEscape = (event) => {
    if (event.keyCode === 27) closeSearch()
}

/**
 * Setup event listeners for a given toggle
 * @param toggle
 */
const initToggle = (toggle) => {
    toggle.addEventListener('click', (event) => {
        event.stopPropagation()

        if (document.body.getAttribute('data-search-open') === 'true') {
            closeSearch(toggle)
            return
        }

        openSearch(toggle)
    })
}

if (elSearchOverlay) {
    elSearchField = elSearchOverlay.querySelector('[data-search-input]')
    initToggle(elSearchToggle)
    initToggle(elMobileSearchToggle)

    elSearchOverlay.addEventListener('click', (event) => {
        event.stopPropagation()
    })
}

export { closeSearch }
